import { Controller } from 'stimulus';

class CustomNumberController extends Controller {
  static targets = [
    'input',
  ];

  up() {
    const inputVal = this.inputTarget.value;

    this.setNewValue(parseInt(inputVal, 10) + 1);
  }

  down() {
    const inputVal = this.inputTarget.value;

    this.setNewValue(parseInt(inputVal, 10) - 1);
  }

  setNewValue(value) {
    const { min, max } = this.inputTarget;
    let newValue = value;

    if (min && newValue < min) {
      newValue = min;
    }

    if (max && newValue > max) {
      newValue = max;
    }

    this.inputTarget.value = newValue;
  }
}

export default CustomNumberController;
